module.exports = "/images/side-my-account-active.svg?f2fb76f53cab2694a14d3e6404fa3491";